var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKonvergeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.905,
    height: 24,
    viewBox: "0 0 78.905 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KONVERGE-WEBSITE-LOGO",
    transform: "translate(-5.07 -7.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M162.336,39.671c0-.051,0-.111-.055-.142a1.871,1.871,0,0,1-.039-1.011,1.224,1.224,0,0,1,1.153-.928h.241a1.232,1.232,0,0,1,1.157,1.141,1.69,1.69,0,0,1-.312,1.184.146.146,0,0,0-.111.1,3.158,3.158,0,0,1-.47.217l-.186.059A1.465,1.465,0,0,1,162.336,39.671Z",
    transform: "translate(-95.089 -18.452)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(49.304 27.618)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.39,
    cy: 1.39,
    r: 1.39,
    transform: "translate(53.299 26.272)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(56.39 25.292)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.813,
    cy: 0.813,
    r: 0.813,
    transform: "translate(59.118 24.404)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.553,
    cy: 0.553,
    r: 0.553,
    transform: "translate(61.377 23.733)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.383,
    cy: 0.383,
    r: 0.383,
    transform: "translate(63.153 23.153)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(64.571 22.624)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 0.166,
    cy: 0.166,
    r: 0.166,
    transform: "translate(65.755 22.26)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.146,
    cy: 0.146,
    r: 0.146,
    transform: "translate(66.572 21.909)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(77.666 26.272)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.813,
    cy: 0.813,
    r: 0.813,
    transform: "translate(75.597 25.123)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 0.553,
    cy: 0.553,
    r: 0.553,
    transform: "translate(73.971 24.242)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 0.383,
    cy: 0.383,
    r: 0.383,
    transform: "translate(72.625 23.492)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(71.46 22.825)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 0.166,
    cy: 0.166,
    r: 0.166,
    transform: "translate(70.587 22.347)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 0.146,
    cy: 0.146,
    r: 0.146,
    transform: "translate(69.857 21.913)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(67.318 7.1)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 0.813,
    cy: 0.813,
    r: 0.813,
    transform: "translate(67.579 10.085)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.553,
    cy: 0.553,
    r: 0.553,
    transform: "translate(67.84 12.548)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 0.383,
    cy: 0.383,
    r: 0.383,
    transform: "translate(68.009 14.491)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(68.1 16.05)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 0.166,
    cy: 0.166,
    r: 0.166,
    transform: "translate(68.226 17.341)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 0.146,
    cy: 0.146,
    r: 0.146,
    transform: "translate(68.242 18.241)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M5.07,28.831V19h2.1v4.449L10.455,19h2.432l-3.5,4.473,3.628,5.357H10.483L7.178,23.7v5.132Z",
    transform: "translate(0 -7.202)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M32.9,30.172a3.38,3.38,0,0,1-1.038,2.523,3.616,3.616,0,0,1-2.633,1.011,3.668,3.668,0,0,1-2.645-1.011,3.577,3.577,0,0,1,0-5.053,3.952,3.952,0,0,1,5.275-.012A3.379,3.379,0,0,1,32.9,30.172Zm-1.95,0a1.757,1.757,0,0,0-.47-1.287,1.9,1.9,0,0,0-2.519,0,2.021,2.021,0,0,0,0,2.578,1.654,1.654,0,0,0,1.255.486,1.686,1.686,0,0,0,1.259-.486A1.753,1.753,0,0,0,30.954,30.172Z",
    transform: "translate(-12.39 -11.816)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M47.85,33.466V26.88h1.875v1.034a3.514,3.514,0,0,1,1.117-.955,3.182,3.182,0,0,1,2.594-.047,1.942,1.942,0,0,1,.825.79,2.2,2.2,0,0,1,.209.624,6.653,6.653,0,0,1,.063,1.086v4.051H52.647V30.2a3.073,3.073,0,0,0-.28-1.607A1.117,1.117,0,0,0,51.4,28.2a1.615,1.615,0,0,0-.73.17,1.469,1.469,0,0,0-.553.466,1.532,1.532,0,0,0-.257.537,4.252,4.252,0,0,0-.075.924v3.158Z",
    transform: "translate(-25.89 -11.837)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M69.411,33.805,66.73,27.22h2.211l1.113,3.427a7.989,7.989,0,0,1,.217.79,5.855,5.855,0,0,1,.118.683c.055-.343.111-.64.17-.88a4.828,4.828,0,0,1,.19-.659l1.121-3.36h2.175l-2.708,6.585Z",
    transform: "translate(-37.317 -12.177)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M93.123,30.646H88.169a1.741,1.741,0,0,0,.517,1.066,1.6,1.6,0,0,0,1.1.351,1.9,1.9,0,0,0,.9-.2,1.65,1.65,0,0,0,.632-.612l1.548.79a3.553,3.553,0,0,1-1.307,1.287,3.683,3.683,0,0,1-1.82.418,3.372,3.372,0,0,1-2.531-.951,3.9,3.9,0,0,1,.043-5.121,3.34,3.34,0,0,1,2.5-1,3.3,3.3,0,0,1,2.487.916,3.506,3.506,0,0,1,.912,2.554v.209C93.155,30.41,93.135,30.508,93.123,30.646Zm-1.9-1.149a1.429,1.429,0,0,0-.454-.944,1.516,1.516,0,0,0-1.015-.32,1.579,1.579,0,0,0-1.03.32,1.48,1.48,0,0,0-.5.944Z",
    transform: "translate(-49.142 -11.841)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M109.156,28.553a3.028,3.028,0,0,1,.833-1.437,1.942,1.942,0,0,1,1.342-.478,4.374,4.374,0,0,1,.6.067l.118.02-.288,2.057a2.7,2.7,0,0,0-.43-.13,2.614,2.614,0,0,0-.462-.043,1.579,1.579,0,0,0-1.255.446,2.3,2.3,0,0,0-.395,1.5v2.9H107.3V26.867h1.887Z",
    transform: "translate(-61.869 -11.824)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M127.477,33.344a5.9,5.9,0,0,1-.126,1.465,1.725,1.725,0,0,1-.426.734,2.562,2.562,0,0,1-1.105.683,5.3,5.3,0,0,1-1.631.221,4.738,4.738,0,0,1-2.44-.505,1.86,1.86,0,0,1-.908-1.556h2.1a.734.734,0,0,0,.351.569,1.836,1.836,0,0,0,.9.182,1.417,1.417,0,0,0,1.125-.395,2.045,2.045,0,0,0,.336-1.35V32.44a2.515,2.515,0,0,1-.924.908,2.618,2.618,0,0,1-1.279.3,2.716,2.716,0,0,1-2.167-.944,3.806,3.806,0,0,1-.79-2.562,3.826,3.826,0,0,1,.79-2.566,2.724,2.724,0,0,1,2.171-.936,2.475,2.475,0,0,1,1.279.34,2.669,2.669,0,0,1,.944.987v-1.1h1.8Zm-1.733-3.19a2.01,2.01,0,0,0-.446-1.378,1.528,1.528,0,0,0-1.208-.509,1.579,1.579,0,0,0-1.228.509,2.017,2.017,0,0,0-.446,1.382,1.974,1.974,0,0,0,.438,1.358,1.769,1.769,0,0,0,2.448,0A2.017,2.017,0,0,0,125.744,30.154Z",
    transform: "translate(-69.847 -11.822)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M148.789,30.648h-4.955a1.725,1.725,0,0,0,.521,1.066,1.579,1.579,0,0,0,1.094.351,1.9,1.9,0,0,0,.9-.2,1.658,1.658,0,0,0,.636-.612l1.544.79a3.553,3.553,0,0,1-1.3,1.287,3.739,3.739,0,0,1-1.82.418,3.387,3.387,0,0,1-2.535-.951,3.914,3.914,0,0,1,.043-5.121,3.352,3.352,0,0,1,2.5-1,3.3,3.3,0,0,1,2.487.94,3.474,3.474,0,0,1,.912,2.554v.186C148.821,30.412,148.8,30.51,148.789,30.648Zm-1.9-1.149a1.429,1.429,0,0,0-.454-.944,1.516,1.516,0,0,0-1.015-.32,1.579,1.579,0,0,0-1.03.32,1.5,1.5,0,0,0-.493.944Z",
    transform: "translate(-82.833 -11.843)",
    fill: "#020067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M171.68,29.328l3.755-9.838h2.4l3.8,9.838h-2.393l-.79-2.092h-3.81l-.687,2.092Zm6.266-3.747-1.105-3.158c-.028-.095-.067-.253-.118-.482s-.1-.509-.154-.845c-.059.316-.115.6-.17.857s-.095.418-.122.505L175.213,25.6Z",
    transform: "translate(-100.832 -7.498)",
    fill: "#fd7e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M199.6,29.328V19.49h2.1v9.838Z",
    transform: "translate(-117.729 -7.498)",
    fill: "#fd7e00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonvergeLogo);
export default __webpack_public_path__ + "static/media/konvergeLogo.cb686ce33891bf963e2f9ac6fc72a188.svg";
export { ForwardRef as ReactComponent };